import Vue from 'vue';
import axios from 'axios';
import router from '../router/index';


Vue.prototype.$axios = axios;

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (error.response.status === 401) {
      window.sessionStorage.removeItem('userInfo');
      window.sessionStorage.removeItem('pushToken');
      window.localStorage.removeItem('challengeInfo');
      router.push('/');
    }else if(error.response.status === 500){
      // alert('페이지 오류가 생겼습니다.');
      router.push('/error');
    }else{
      router.push('/error');
    }
    return Promise.reject(error);
  })

export default axios;